var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { Acr, createAuth } from '@spotify-internal/oauth-silent-authentication';
const ACRS = [Acr.S4A_2FA];
export const getSilentAuth = (clientId) => {
    if (typeof window === 'undefined') {
        throw new Error('server environments not supported');
    }
    const hasSupport = window.location.protocol === 'https:' &&
        /\.spotify\.(net|com)$/.test(window.location.hostname);
    if (!hasSupport) {
        throw new Error('failed to get access token');
    }
    const authServerConfig = process.env.USE_TEST_ACCOUNTS
        ? { url: 'https://accounts-shared.spotify.net' }
        : undefined;
    const scopes = process.env.USE_TEST_ACCOUNTS
        ? []
        : ['user-read-email', 'user-read-private', 'ugc-image-upload'];
    return createAuth({
        clientId,
        scopes,
        acrs: ACRS,
    }, authServerConfig);
};
export function getSilentAuthToken(clientId) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            const silentAuth = getSilentAuth(clientId);
            const [token, expiresIn] = yield silentAuth.tokenProvider();
            return [token, expiresIn];
        }
        catch (error) {
            if (error.error === 'login_required') {
                return [undefined, Infinity];
            }
            throw error;
        }
    });
}
//# sourceMappingURL=silentAuth.js.map